const { algoliasearch, instantsearch } = window;
const searchClient = algoliasearch('QSWPLYTOQG', '2ab640590559a6bcaf7461ce1b1ada27');
const indexName = 'cdn_public_v1_en-GB';
const widgetsForAttributes = {
  'meta.product-lvl1': 'menu',
  'meta.product-lvl2': 'refinementList',
  'meta.publication-type': 'refinementList',
};

const search = instantsearch({
  searchClient,
  indexName: indexName,
  routing: {
    stateMapping: {
      stateToRoute(uiState) {
        const state = uiState[indexName];
        const route = {
          query: state.query,
          page: state.page
        };
        ['refinementList', 'hierarchicalMenu', 'menuSelect', 'menu'].forEach((widget) => {
          if (state[widget]) {
            for (var attribute in state[widget]) {
              route[attribute] = state[widget][attribute];
            }
          }
        });
        return route;
      },
      routeToState(routeState) {
        const state = {
          [indexName]: {
            refinementList: {},
            hierarchicalMenu: {},
            menuSelect: {},
            menu: {},
          },
        };
        for (const key in routeState) {
          if (key in widgetsForAttributes) {
            const widget = widgetsForAttributes[key];
            state[indexName][widget][key] = routeState[key];
            continue;
          }
          ['query', 'page'].forEach((attribute) => {
            if (key === attribute) {
              state[indexName][attribute] = routeState[key];
            }
          });
        }
        return state;
      },
    },
  },
});

function get(fallback, obj, level, ...rest) {
  if ((obj === undefined) || (obj === null)) return fallback;
  if (rest.length === 0 && obj.hasOwnProperty(level)) {
      if ((obj[level] === null) && (fallback !== null)) return fallback;
      return obj[level];
  }
  return get(fallback, obj[level], ...rest);
}

function set(obj, level, ...rest) {
  if ((obj === undefined) || (obj === null)) throw Error("Invalid object supplied!");
  if ((level === undefined) || (level === null)) throw Error("At least one level must be supplied");
  if (rest.length === 0) throw Error("A value must be supplied as the last argument!");
  if (rest.length === 1) {
    obj[level] = rest[0];
  } else {
    set(obj[level], ...rest);
  }
}

function transformItems(attributes, items) {
  if (attributes) {
    if (!Array.isArray(attributes)) attributes = [attributes];
    // a specific attribute (facet)
    return items.map((item) => {
      for (const attribute of attributes) {
        if ((attribute in transformations) && (item.label in transformations[attribute])) {
          return {
            ...item,
            label: transformations[attribute][item.label],
            highlighted: transformations[attribute][item.label],
          };
        }
      }
      return item;
    });
  } else {
    // search results
    return items.map((item) => {
      let result = Object.assign({}, item);
      for (let attribute in item) {
        if ((attribute in transformations) && (item[attribute] in transformations[attribute])) {
          result = {
            ...result,
            [attribute]: transformations[attribute][item[attribute]]
          };
        } else {
          Object.keys(transformations).forEach((attribute) => {
            let fields = attribute.split('.');
            if (fields.length > 0) {
              let value = get(null, item, ...fields);
              if ((value != null) && (value in transformations[attribute])) {
                set(result, ...fields, transformations[attribute][value]);
              }
            }
          })
        }
      }
      return result;
    });
  }
}

search.addWidgets([
  instantsearch.widgets.searchBox({
    container: '#searchbox',
    placeholder: 'Search for any content...',
  }),
  instantsearch.widgets.hits({
    container: '#hits',
    transformItems: transformItems.bind(this, null),
    templates: {
      item: `
      <article class="card">
        <div class="card-body">
          <h4 class="card-title">{{ meta.product-lvl1 }} - {{ meta.product-lvl2 }} {{ meta.publication-type }}</h4>
          <a class="text-decoration-none" href="https://demo.simonsoftcdn.com{{ url }}">
          <h6 class="card-subtitle mb-2">{{ hierarchy.lvl1 }} > {{ hierarchy.lvl2 }}</h6>
          </a>
          <p class="card-text">{{#helpers.snippet}}{ "attribute": "content" }{{/helpers.snippet}}</p>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col">
            <p>{{docno}} rev {{versionrelease}} </p>
            </div>
            <div class="col text-end">
              <language-picker
                size="sm"
                class="navbar-language-picker"
                variant="primary"
                menuVariant="primary"
                docno="{{docno}}"
                version="{{version}}"
                urlprefix="https://demo.simonsoftcdn.com"
                algoliaAppId="QSWPLYTOQG"
                algoliaApiKey="2ab640590559a6bcaf7461ce1b1ada27"
                algoliaIndexName="cdn_public_v1"
              ></language-picker>
            </div>
          </div>
        </div>
      </article>
`,
    },
  }),
  instantsearch.widgets.menu({
    container: '#meta-product-lvl1-menu',
    transformItems: transformItems.bind(this, 'meta.product-lvl1'),
    attribute: 'meta.product-lvl1',
  }),
  instantsearch.widgets.refinementList({
    container: '#meta-product-lvl2-list',
    transformItems: transformItems.bind(this, 'meta.product-lvl2'),
    attribute: 'meta.product-lvl2',
  }),
  instantsearch.widgets.refinementList({
    container: '#meta-publication-type-list',
    transformItems: transformItems.bind(this, 'meta.publication-type'),
    attribute: 'meta.publication-type',
  }),
  instantsearch.widgets.pagination({
    container: '#pagination',
  }),
  instantsearch.widgets.configure({
    distinct: "true",
    facetingAfterDistinct: "true",
    filters: "format:web",
  }),
]);

search.start();
